// 선택은 ID, 실행 위치는 현재 배열에서 계산한다. 중복 ID는 임의의 첫 행으로 처리하지 않는다.
export function uniqueRowIndex(rows, id) {
  if (id == null) return -1;
  const key = String(id);
  const index = rows.findIndex((row) => String(row.problem_id) === key);
  return index >= 0 && rows.findIndex((row, i) => i > index && String(row.problem_id) === key) < 0 ? index : -1;
}

export function movePaperRow(rows, id, to) {
  const from = uniqueRowIndex(rows, id);
  if (from < 0 || !Number.isInteger(to) || to < 0 || to >= rows.length || from === to) return rows;
  const next = rows.slice();
  const [row] = next.splice(from, 1);
  next.splice(to, 0, row);
  return next;
}

export function swapPaperRows(rows, id, to) {
  const from = uniqueRowIndex(rows, id);
  if (from < 0 || !Number.isInteger(to) || to < 0 || to >= rows.length || from === to) return rows;
  const next = rows.slice();
  [next[from], next[to]] = [next[to], next[from]];
  return next;
}

// boundary는 원래 배열의 행 사이 경계다. 출발 행을 제거한 뒤의 최종 위치로 변환한다.
export function movePaperRowAtBoundary(rows, id, boundary) {
  const from = uniqueRowIndex(rows, id);
  if (from < 0 || !Number.isInteger(boundary) || boundary < 0 || boundary > rows.length) return rows;
  return movePaperRow(rows, id, boundary > from ? boundary - 1 : boundary);
}

export function parsePaperNumber(value, count) {
  const text = String(value).trim();
  if (!/^\d+$/.test(text)) return null;
  const number = Number(text);
  return Number.isSafeInteger(number) && number >= 1 && number <= count ? number : null;
}

// DOM 위치는 호출할 때마다 읽는다. 행 사이 여백도 같은 경계로 판정한다.
export function insertionBoundary(rects, y) {
  const before = rects.findIndex((rect) => y <= rect.top + rect.height / 2);
  return before < 0 ? rects.length : before;
}
